import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-rounded-hover-box',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './rounded-hover-box.component.html',
  styleUrl: './rounded-hover-box.component.scss',
  host: {
    '[class.border]': 'border()',
    '[class.active]': 'active()',
  },
})
export class RoundedHoverBoxComponent {
  border = input<boolean>();
  active = input<boolean>();
}
